var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow-Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2874 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7803 20.0303C15.4874 20.3232 15.0126 20.3232 14.7197 20.0303L7.21967 12.5303C6.92678 12.2374 6.92678 11.7626 7.21967 11.4697L14.7197 3.96967C15.0126 3.67678 15.4874 3.67678 15.7803 3.96967C16.0732 4.26256 16.0732 4.73744 15.7803 5.03033L8.81066 12L15.7803 18.9697C16.0732 19.2626 16.0732 19.7374 15.7803 20.0303Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.5f2d0f7502598a144285154b811fe930.svg";
export { ForwardRef as ReactComponent };